
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/cardiovascular-week",
      function () {
        return require("private-next-pages/special/cardiovascular-week/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/cardiovascular-week"])
      });
    }
  